var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$store.state.LanguageText[301]))]),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$store.state.LanguageText[311]))])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }